import Box from '@mui/material/Box'
import { Divider, Stack, Typography } from '@mui/material'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import FileDetailsComponent from '../../components/Architecture/FileDetailsComponent'
import { useCallback } from 'react'
import { UserRoleNames } from '../../models/AccessControl'

const selectedFileSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedFile,
)
const selectedAssignedProjectSelector = createSelector(
  [(state: RootState) => state.review],
  (review) => review.selectedProject,
)

interface RightPanelProps {}

const RightPanelComponent: React.FC<RightPanelProps> = () => {
  const selectedProject = useSelector(selectedFileSelector)
  const selectedAssignedProject = useSelector(selectedAssignedProjectSelector)
  const user = useSelector((state: RootState) => state.auth.user)

  const renderRightPanel = useCallback(() => {
    switch (user?.role.name) {
      case UserRoleNames.Admin:
      case UserRoleNames.LeadingArchitect:
      case UserRoleNames.Architect:
        return renderArchitectPanel()
      case UserRoleNames.EngineeringAdmin:
      case UserRoleNames.LeadingStructuralEngineer:
      case UserRoleNames.LeadingElectricalEngineer:
      case UserRoleNames.StructuralEngineer:
      case UserRoleNames.ElectricalEngineer:
        return renderEngineerPanel()
      default:
        return renderArchitectPanel()
    }
  }, [user, selectedProject, selectedAssignedProject])

  const renderArchitectPanel = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          background: '#fff',
          borderRadius: '6px',
          border: '1px solid #E4E4E4',
          boxShadow: '0px 3px 5px 0px #0000001A',
          p: '0.75rem',
          alignItems: 'flex-end',
        }}
      >
        {selectedProject && (
          <Stack width='100%' gap='0.5rem'>
            <Divider />
            <Typography
              sx={{
                fontSize: '0.7rem',
                color: '#797979',
                lineHeight: 'normal',
                fontWeight: 500,
              }}
            >
              Selected Project Details
            </Typography>
            <FileDetailsComponent file={selectedProject} />
          </Stack>
        )}
      </Box>
    )
  }

  const renderEngineerPanel = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          background: '#fff',
          borderRadius: '6px',
          border: '1px solid #E4E4E4',
          boxShadow: '0px 3px 5px 0px #0000001A',
          p: '0.75rem',
          alignItems: 'flex-end',
        }}
      >
        {selectedAssignedProject && (
          <Stack width='100%' gap='0.5rem'>
            <Divider />
            <Typography
              sx={{
                fontSize: '0.7rem',
                color: '#797979',
                lineHeight: 'normal',
                fontWeight: 500,
              }}
            >
              Selected Project Details
            </Typography>
            <FileDetailsComponent file={selectedAssignedProject.file} />
          </Stack>
        )}
      </Box>
    )
  }

  return <>{renderRightPanel()}</>
}

export default RightPanelComponent
